module.exports = __webpack_public_path__ + "static/media/img-datos-empresa.3f5ceb09.png";